import * as R from 'ramda';
import { HttpClient, JSON_STRING, withBaseUrl } from "../../services/http/http-client";
import { BOOKINGS_STRING, BOOKING_URL } from "../../modules/booking/services/booking-service";

export const FILES_URL = '/files.pl'

const ADD_DOCUMENT_NEW = 'add_document_new';
const CALENDAR_DATES = 'calendar_dates';
const SEARCH_UNRELATED_DOCS_NEW = 'search_unrelated_docs_new';

const MAKE_DOCUMENT_RELATIONS = 'make_document_relations';
const DELETE_DOCUMENT_RELATION = 'delete_document_relation';
export const FileService = {
  // https://staging.detailsdetails.eu/berlin3/files.pl?
  // action=add_document_new&
  // external_id=3596&
  // external_table=calendar_dates&
  // output=json
  findUnrelatedFileList: ({
    externalId,
    externalTable
  }) => HttpClient.post(FILES_URL, {
    action: ADD_DOCUMENT_NEW,
    external_id: externalId,
    external_table: externalTable,
    output: JSON_STRING
  }),
  findFileByName: ({
    section = BOOKINGS_STRING,
    key,
    externalId,
    externalTable
  }) => HttpClient.post(FILES_URL, {
    section,
    action: SEARCH_UNRELATED_DOCS_NEW,
    search_key: key,
    external_id: externalId,
    external_table: externalTable,
    output: JSON_STRING
  }),
  insertDocumentRelation: ({
    section = BOOKINGS_STRING,
    fileIds,
    externalId,
    externalTable
  }) => HttpClient.post(FILES_URL, {
    section,
    action: MAKE_DOCUMENT_RELATIONS,
    files: fileIds,
    external_id: externalId,
    external_table: externalTable,
    returnType: JSON_STRING,
  }),
  deleteFile: ({
    fileId,
    fileRelatoinId
  }) => {
    return HttpClient.post(FILES_URL, {
      action: DELETE_DOCUMENT_RELATION,
      file_id: fileId,
      file_relation_id: fileRelatoinId,
    })
  },
  createFileUrl: ({

  }) => HttpClient.post(BOOKING_URL, {

  }),
  uploadFile: (formData) => HttpClient.postFormData(FILES_URL, formData),

  shortenFileURL: ({
    file_url
  }) => HttpClient.post(BOOKING_URL, {
    section: 'bookings',
    action: 'create_shorten_url_link_for_file',
    file_url,
  })
};


